import useAssessments from "./useAssessments";
import useLang from "../../../hooks/useLang";
import useAssessmentPageBlock from "./useAssessmentPageBlock";
import useOrganisationId from "../../organisations/hooks/useOrganisationId";

const useAssessmentsList = () => {
  const lang = useLang();
  const organisationId = useOrganisationId();
  const assessments = useAssessments();

  const items = useAssessmentPageBlock({ assessments, organisationId });

  const page = {
    hasAccess: assessments?.hasAccess,
    header: {
      title: assessments?.isLoading
        ? lang("assessments.assessments_loading")
        : lang("assessments.title"),
      /*
      buttons: [
        {
          caption: lang("assessments.new"),
          to: "/assessments/new",
        },
      ],
      */
    },
    paging: { ...assessments?.pagination },
    items,
  };
  return page;
};

export default useAssessmentsList;
